import { useEffect, useState } from "react";
import Product from "./Product";
import "./Product.css";
import { data } from "react-router-dom";
function ProductList(){
    const api_url ="https://fakestoreapi.com/products";
    const [products,setProducts]= useState([]);
    const [categories,setCategories]= useState([]);
    const getProduct= ()=>{
        fetch(api_url)
            .then(res=>res.json())            
            .then(product=>setProducts(product));
    }
    const getCategories=()=>{
        fetch(`${api_url}/categories`)
            .then(res=>res.json())            
            .then(category=>setCategories(category));
    }

    useEffect(()=>{
        getProduct();
        getCategories();
    },[]);
    const getProductInCategory=(categoryName)=>{
        fetch(`${api_url}/category/${categoryName}`)
            .then(res=>res.json())            
            .then(data=>setProducts(data));

    }
    return(
        < >
            <h2 className="text-center">Our Products</h2>
            <div className="container">
                <div className="category">
                    <button className="btn btn-light" onClick={()=>{getProduct();}}>
                        All
                    </button>
                    {categories.map((category)=>{
                        return(
                            <button className="btn btn-light" onClick={()=>{getProductInCategory(category);}} key={category}>
                                {category}
                            </button>
                        );
                    })}
                </div>
                <div className="row">
                    {products.map((product)=>{
                        return(
                            <div className="col-3" key={product.id}>
                                <Product Product={product} showButton={true}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        </ >
    )
}
export default ProductList;